export default function extractFeatureFlagsFromLocation(location) {
    const queryString = location.search;
    if (!queryString) {
        return [];
    }
    const parts = queryString.substring(1).split('&');
    const result = [];
    for (let i = 0; i < parts.length; i++) {
        const pair = parts[i].split('=', 2);
        const key = decodeURIComponent(pair[0]);
        const value = pair[1] !== undefined ? decodeURIComponent(pair[1]) : "";
        if (key === "activeInDevFeatures") {
            result.push.apply(result, value.split(','));
        }
    }
    return result;
}
